import { useContext, useEffect } from "react";
import { messageContext, MessageListener } from "./context";

export function useMessageListener(memoizedFunction: MessageListener) {
    const {addListener, removeListener} = useContext(messageContext);

    useEffect(()=>{
        addListener(memoizedFunction);
        return () => removeListener(memoizedFunction);
    },[addListener, memoizedFunction, removeListener]);
}

export function usePostMessage() {
    const {post} = useContext(messageContext);

    return post;
}